<style type="text/css" media="screen" scoped>
.method-option-box{
	width: 90px;
	/*padding: 0px 15px;*/
	height: 55px;
	background: #FFFFFF;
	box-shadow: 0px 5px 10px rgba(162, 158, 158, 0.2);
	border-radius: 10px;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 19px;
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	letter-spacing: 0.015em;
	color: #4F4D4D;
	padding-top: 8px;
	margin:5px; 
	border: 2px solid #FFFFFF ;
	vertical-align: middle;
}
.active-method{
	border: 2px solid #1DC895 !important;
}
.agent-documet-lable{
	display: block;
	width:100%;
	height:50px;
	padding-top: 10px;
	color: #1DC895;
}
</style>

<template>
	<div class="pt-10">
		<v-form ref="add_agent_form"  lazy-validation @submit.prevent="addAgent()">
			<v-row justify="start" class="custome-form">
				<v-col cols="6" md="4">
					<v-row  >
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.NAME}}</label>
							<v-text-field
							:placeholder="$lang.NAME"
							v-model="form.agent_name"
							single-line
							outlined
							dense
							:rules="$rules.NAME"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.PHONE_NUMBER}}</label>
							<v-text-field
							:placeholder="$lang.PHONE_NUMBER"
							v-model="form.agent_phone_number"
							single-line
							outlined
							dense
							maxlength="10"
							:rules="$rules.mobileRule"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.ALTERNATE_PHONE_NUMBER}}</label>
							<v-text-field
							:placeholder="$lang.ALTERNATE_PHONE_NUMBER"
							v-model="form.agent_alternate_phone_number"
							single-line
							outlined
							dense
							maxlength="10"
							:error-messages="(form.agent_alternate_phone_number)&&(form.agent_phone_number==form.agent_alternate_phone_number)?$messages.MATCHING_PHONE_NUMBER_ERROR:''"
							:rules="$rules.mobileRule"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.AADHAAR_NUMBER}}</label>
							<v-text-field
							:placeholder="$lang.AADHAAR_NUMBER"
							v-model="form.agent_aadhar_number"
							single-line
							outlined
							dense
							maxlength="12"
							:rules="$rules.AADHAAR_NUMBER"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.DL_NUMBER}}</label>
							<v-text-field
							:placeholder="$lang.DL_NUMBER"
							v-model="form.agent_driving_license_number"
							single-line
							outlined
							dense
							:rules="$rules.DL_NUMBER"
							class="uppercase"
							></v-text-field>
						</v-col>


						<v-col cols="12" md="12" class="py-0 px-2 ">
							<label>{{$lang.DL_EXPIRY}}</label>
							<v-menu bottom origin="center center" v-model="date_menu" :close-on-content-click="false" transition="scale-transition" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									v-model="form.agent_driving_license_expiry"
									:placeholder="$lang.YY_MM_DD"
									readonly
									outlined
									single-line
									dense
									v-bind="attrs"
									v-on="on"
									:rules="$rules.DL_EXPIRY"
									></v-text-field>
								</template>
								<v-date-picker :min="today" v-model="form.agent_driving_license_expiry"  @input="date_menu = false" ></v-date-picker>
							</v-menu>
						</v-col>

						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.FULL_ADDRESS}}</label>
							<v-textarea
							clearable
							:placeholder="$lang.FULL_ADDRESS"
							v-model="form.agent_address"
							single-line
							outlined
							dense
							auto-grow
							rows="2"
							:rules="$rules.fullAddressRule"
							></v-textarea>
						</v-col> 

						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.ASSETS}}</label>
							<v-textarea
							clearable
							:placeholder="$lang.ASSETS"
							v-model="form.agent_assets"
							single-line
							outlined
							dense
							auto-grow
							rows="2"
							:rules="$rules.ASSETS"
							></v-textarea>
						</v-col> 

					</v-row>
				</v-col>
				<!-- BLANK DATA -->
				<v-col cols="6" md="1" class="border-r large-screen">
				</v-col>
				<!--  -->
				<v-col cols="6" md="5">
					<v-row  class="pl-5" >
						<v-col cols="12" md="11" class="py-0 px-2 text-left">
							<div class="m-t-negative-10 mb-5">
								<label>{{$lang.TYPE}}</label>
								<div class="text-center mt-3" v-if="is_edit">
									<div v-for="(item, i) in agent_type_option " :key="i" 
									class="method-option-box "  
									:class="form.agent_type==item?'active-method':''">
									{{item}}
								</div>
							</div>
							<div class="text-center mt-3" v-else>
								<div v-for="(item, i) in agent_type_option " :key="i" 
								class="method-option-box cursor-pointer"  @click="form.agent_type=item" 
								:class="form.agent_type==item?'active-method':''">
								{{item}}
							</div>
						</div>
					</div>
				</v-col>
				<v-col cols="12" md="11" class="py-0 px-2">
					<label>{{$lang.BANK_NAME}}</label>
					<v-text-field
					:placeholder="$lang.BANK_NAME"
					v-model="form.agent_bank_name"
					single-line
					outlined
					dense	
					maxlength="15"
					:rules="$rules.BANK_NAME"
					></v-text-field>
				</v-col>

				<v-col cols="12" md="11" class="py-0 px-2">
					<label>{{$lang.ACCOUNT_HOLDER_NAME}}</label>
					<v-text-field
					:placeholder="$lang.ACCOUNT_HOLDER_NAME"
					v-model="form.agent_bank_account_holder_name"
					single-line
					outlined
					dense	
					maxlength="15"
					:rules="$rules.ACCOUNT_HOLDER_NAME"
					></v-text-field>
				</v-col>
				<v-col cols="12" md="11" class="py-0 px-2">
					<label>{{$lang.ACCOUNT_NUMBER}}</label>
					<v-text-field
					:placeholder="$lang.ACCOUNT_NUMBER"
					v-model="form.agent_bank_account_number"
					single-line
					outlined
					dense	
					maxlength="50"
					:rules="$rules.ACCOUNT_NUMBER"
					></v-text-field>
				</v-col>

				<v-col cols="12" md="11" class="py-0 px-2">
					<label>{{$lang.IFSC}}</label>
					<v-text-field
					:placeholder="$lang.IFSC"
					v-model="form.agent_bank_ifsc"
					single-line
					outlined
					dense	
					maxlength="15"
					:rules="$rules.IFSC"
					class="uppercase"	
					></v-text-field>
				</v-col>

				<v-col cols="12" md="11" class="py-0 px-2">
					<label>{{$lang.PAN_CARD}}</label>
					<v-text-field
					:placeholder="$lang.PAN_CARD"
					v-model="form.agent_pancard_number"
					single-line
					outlined
					dense	
					maxlength="15"
					:rules="$rules.PAN_CARD"
					class="uppercase"
					></v-text-field>
				</v-col>

				<v-col cols="12" md="11" class="py-0 px-2">
					<label>{{$lang.CREDIT_LIMIT}}</label>
					<v-text-field
					:placeholder="$lang.CREDIT_LIMIT"
					v-model="form.agent_credit_limit"
					single-line
					outlined
					dense	
					maxlength="15"
					:rules="$rules.CREDIT_LIMIT"
					></v-text-field>
				</v-col>
				<v-col cols="12" md="11" class="py-0 px-2">
					<div class="mt-2">
						<v-btn color="primary" block outlined class="br-8 border-w-2" height="50px" >
							<label class="cursor-pointer agent-documet-lable" for="agent_document">
								<input 
								id="agent_document"
								type="file" ref="files" 
								@change="browseFile($event)"
								:accept="$keys.ACCEPTED_IMAGE_FORMATE"  hidden >
								<img src="@/assets/upload-green.svg" alt="img" width="18px" class="mr-1">
								<b>{{$lang.UPLOAD_DOCUMENTS}}</b>
							</label>
						</v-btn>
						<p v-if="document">{{document.name}}</p>

					</div>
				</v-col>


				<v-col cols="12" md="12" class="py-0 px-2">
					<v-btn color="primary" class="signup-btn-style mt-12 px-6" type="submit" :loading="btn_loading">
						<b>Continue</b>
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</v-form>


</div>
</template>
<script type="text/javascript">

export default{
	components:{

	},
	data(){
		return{
			agent_type_option:['Pickup Agent','Delivery Agent','Warehouse Agent'],
			today:new Date().toISOString().substr(0, 10),
			date_menu:false,
			form:{
				agent_name:"",
				agent_phone_number:"",
				agent_alternate_phone_number:"",
				agent_aadhar_number:"",
				agent_driving_license_number:"",
				agent_driving_license_expiry:"",
				agent_assets:"",
				agent_type:'',
				agent_bank_name:"",
				agent_bank_account_number:"",
				agent_bank_account_holder_name:"",
				agent_bank_ifsc:"",
				agent_pancard_number:"",
				agent_credit_limit:"",
				agent_address:"",

			},
			document:null,

			is_edit:false,
			btn_loading:false,
			agent_id:"",
		}
	},
	created(){
		if(this.$route.name=="edit-agent")	{
			this.is_edit=true
			this.agent_id= this.decrypt(this.$route.params.agent_id)
			this.getAgentDetails()
		}
		else{
			let agent_type= this.decrypt(this.$route.query.agent_type)
			if (agent_type!=="All")
				this.form.agent_type=agent_type
		}
	},
	methods:{
		/* Add edit agent details*/ 
		addAgent(){
			const self= this
			if (self.$refs.add_agent_form.validate()==false)
				return false
			
			if(!this.form.agent_type){
				this.showSnakeBar('warning',this.$messages.SELECT_AGENT_TYPE)
				return false
			}

			self.btn_loading=true
			var	form = new FormData();


			form.append("agent_type",self.form.agent_type)  
			form.append("agent_name",self.form.agent_name)
			form.append("agent_phone_number",self.form.agent_phone_number)
			form.append("agent_alternate_phone_number",self.form.agent_alternate_phone_number)
			form.append("agent_aadhar_number",self.form.agent_aadhar_number)
			form.append("agent_driving_license_number",self.form.agent_driving_license_number)
			form.append("agent_driving_license_expiry",self.form.agent_driving_license_expiry)
			form.append("agent_assets",self.form.agent_assets)
			form.append("agent_bank_name",self.form.agent_bank_name)
			form.append("agent_bank_account_number",self.form.agent_bank_account_number)
			form.append("agent_bank_account_holder_name",self.form.agent_bank_account_holder_name)
			form.append("agent_bank_ifsc",self.form.agent_bank_ifsc)
			form.append("agent_pancard_number",self.form.agent_pancard_number)
			form.append("agent_credit_limit",self.form.agent_credit_limit)
			form.append("agent_address",self.form.agent_address)
			// form.append("image",self.form.image)
			form.append("agent_document",self.document)

			let url=self.$urls.ADD_AGENT
			if(self.is_edit){
				url=self.$urls.EDIT_AGENT
				form.append("id",self.agent_id)
			}


			const successHandler = (response) => {
				if (response.data.success){
					if(self.is_edit)
						this.$router.push({name:'employee-details',params:{agent_id:this.encript(self.agent_id)}})
					else
						this.$router.push({name:'employee-details',params:{agent_id:this.encript(response.data.id)}})
					
				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};
			
			this.request_POST(self,url,form,successHandler,null,null,finallyHandler)

		},
		browseFile(e){

			const self= this		
			if(!this.$keys.ACCEPTED_IMAGE_FORMATE.includes(e.target.files[0]['type'])){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.INVALID_FILE, color:'error' })
				return false;
			}
			if(e.target.files[0].size>(1024*1024*this.$keys.MAX_FILE_SIZE)){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.MAX_FILE_SIZE_ERROR+ this.$keys.MAX_FILE_SIZE, color: this.$keys.ERROR })
				return false;
			}
			this.document=e.target.files[0]
			console.log(this.document)
		},
		/* fetching the  agent details for edit */
		getAgentDetails(){

			const self=this
			self.$store.dispatch('setPageLoader', true)
			self.filter_agent_type=status
			let params={
				id:self.agent_id,
			};

			self.table_loading=true;
			const successHandler = (response) => {
				self.form=response.data.data
			};
			const finallyHandler = () => {
				self.$store.dispatch('setPageLoader', false)
			};
			self.request_GET( self,self.$urls.AGENT_PROFILE,params,successHandler,null,null,finallyHandler)
		}


	}

}

</script>